import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // <-- PASUL 1: Importă router-ul din folderul /router
import './api'; // (Acesta este fișierul tău API, e bine)

// Creează instanța aplicației
const app = createApp(App);

// --- ACESTA ESTE PASUL CRITIC ---
// Spune-i aplicației Vue să folosească router-ul pe care l-am importat
app.use(router); 

// Montează aplicația
app.mount('#app');